'use strict';

/**
 * @example <vz-products-carousel>
 *
 * @export
 * @class VZProductsCarousel
 * @extends {HTMLElement}
 */
export default class VZProductsCarousel extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const carousel = this.querySelector('.js-products-carousel');
        const viewport = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

        // Only allow scroll for desktop screens when content may overflow
        if (viewport < 768) return;

        let isScrolling = false;
        let initialXPosition = 0;
        let scrollLeft = 0;

        // Set up event listeners
        carousel.addEventListener('mouseup', () => {
            isScrolling = false;

            // Stop clickable cards from misbehaving
            carousel.dataset.dragging = false;
        });
        carousel.addEventListener('mouseleave', () => {
            isScrolling = false;

            // Stop clickable cards from misbehaving
            carousel.dataset.dragging = false;
        });

        carousel.addEventListener('mousedown', (e) => {
            isScrolling = true;

            // Get scroll initial positions
            const rect = carousel.getBoundingClientRect();

            initialXPosition = e.pageX - rect.left;
            scrollLeft = carousel.scrollLeft;
        });

        carousel.addEventListener('mousemove', (e) => {
            if (!isScrolling) return;

            e.preventDefault();

            // Stop clickable cards from misbehaving
            carousel.dataset.dragging = true;

            // Get new scroll positions
            const rect = carousel.getBoundingClientRect();
            const newXPosition = e.pageX - rect.left;
            const walk = newXPosition - initialXPosition;

            // Update carousel scroll position
            carousel.scrollLeft = scrollLeft - walk;
        });
    }
}

if (!window.customElements.get('vz-products-carousel')) {
    window.customElements.define('vz-products-carousel', VZProductsCarousel);
}
